// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__GpMoP","loader":"Loader_loader__PC-Kr","l":"Loader_l__eFvaL"};